export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Size'
    },
    sort: 'player.count',
    lang: {
        name: 'Play Size',
        category: ['User', 'Plays'],
        description: 'Number of players in a play.',
        views: ['list', 'sheet'],
        contexts: ['plays']
    },
    filters: ['play.size']
}